import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeEmbedSection'
 * @name TypeEmbedSectionFields
 * @type {TypeEmbedSectionFields}
 * @memberof TypeEmbedSection
 */
export interface TypeEmbedSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'embedCode' (Embed Code)
     * @name Embed Code
     * @localized false
     */
    embedCode: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'embedSection' (Embed Section)
 * @name TypeEmbedSectionSkeleton
 * @type {TypeEmbedSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-04-13T11:35:53.032Z
 * @version 3
 */
export type TypeEmbedSectionSkeleton = EntrySkeletonType<TypeEmbedSectionFields, "embedSection">;
/**
 * Entry type definition for content type 'embedSection' (Embed Section)
 * @name TypeEmbedSection
 * @type {TypeEmbedSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-04-13T11:35:53.032Z
 * @version 3
 */
export type TypeEmbedSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeEmbedSectionSkeleton, Modifiers, Locales>;

export function isTypeEmbedSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeEmbedSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'embedSection'
}
